import { Link } from 'react-router-dom';
import styled from 'styled-components';

// Import styles
import { flex } from 'components/styles';

// Import icons
import { ReactComponent as IconPlaySVG } from 'assets/icons/play.svg';
import { ReactComponent as IconBasketSVG } from 'assets/icons/ic_basket.svg';
import { ReactComponent as IconLockSVG } from 'assets/icons/ic_lock_second.svg';

// API-URL
const { REACT_APP_API_URL } = process.env;

export const Wrapper = styled.div`
	position: relative;
	width: ${({ width }) => width}px;
	height: ${({ height }) => height}px;
	padding: 0.3rem;
	overflow: hidden;

	${flex()}
`;

export const BgGradientStyled = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	background: linear-gradient(
		205deg,
		rgba(47, 215, 255, 1) 12%,
		rgba(23, 129, 247, 1) 75%
	);
	opacity: 0.6;
	z-index: -1;
`;

export const Content = styled.div`
	height: 100%;
	width: 100%;
	background: url('${REACT_APP_API_URL}/assets/${({ id }) => id}/poster') black;
	background-size: cover;

	${flex()}
`;

export const Info = styled.div`
	background-color: rgba(0, 0, 0, 0.58);
	height: 100%;
	width: 100%;
	padding: 3rem;
	color: ${({ theme }) => theme.white};
	${flex()}
	flex-direction: column;
	text-align: center;
`;

export const EpisodeNumber = styled.span`
	font-size: 1.8rem;
`;

export const Title = styled.div`
	font-size: 1.4rem;
	font-weight: 300;
	color: ${({ theme }) => theme.grayLight};
`;

export const IconPlay = styled(IconPlaySVG)`
	height: 6vh;
`;

export const IconBasket = styled(IconBasketSVG)`
	height: 6vh;
`;

export const IconLock = styled(IconLockSVG)`
	height: 6rem;
	width: 6rem;
`;

export const StyledLink = styled(Link)`
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const Button = styled.button`
	border: none;
	background: none;
	cursor: pointer;
	width: 100%;
	height: 100%;
`;
